export default __webpack_public_path__ + "static/brand-image_1x-bc42135e092a54bfe86bdac35a2841d8.jpg";